import React, {Fragment, useEffect, useState} from 'react';
import {Wrapper, StatusMessage} from './SystemStatus.style';
import Markdown from 'markdown-to-jsx';
import {markdownConvert} from '../../helpers/string.helper';

const SystemStatus = ({systemMessages}) => {
  const [messages, setMessages] = useState(null);

  useEffect(() => {
    if (!systemMessages) {
      setMessages(null);
      return;
    }

    if (systemMessages.maintenance?.length) {
      setMessages(systemMessages.maintenance);
    } else if (systemMessages.announcement?.length) {
      setMessages(systemMessages.announcement);
    } else {
      setMessages(null);
    }
  }, [systemMessages]);

  if (!messages) return null;

  return (
    <Wrapper>
      {messages.map((msg, i) => {
        const convertedMsg = markdownConvert(decodeURIComponent(msg.message));

        if (!convertedMsg) return null;

        return (
          <Fragment key={`${i}-${msg.heading}`}>
            <StatusMessage>
              <Markdown>{convertedMsg}</Markdown>
            </StatusMessage>
          </Fragment>
        );
      })}
    </Wrapper>
  );
};

export default SystemStatus;
